import template from './mechvent.html';
import controller from './mechvent.controller';
import './mechvent.styl';

let mechventComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default mechventComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/mechvent/mechvent.component.js